import { Close, Description, Title } from '@radix-ui/react-dialog';
import { Dispatch, SetStateAction } from 'react';
import { ZodError, ZodIssue } from 'zod';

import { ApiError, ApiErrorDetails } from '@/lib/errors/api';
import { JupiterApiError, JupiterApiErrorDetails } from '@/lib/errors/jupiter';

import { dialogCloseBtnStyles } from '@/styles/dialog';
import { fontStyles } from '@/styles/typography';

import { XIcon } from '@/ui/Icons/XIcon';
import { Modal } from '@/ui/Modal';

interface DetailsModalProps {
  /** The error */
  error: ZodError | ApiError | JupiterApiError | Error;
  /** Whether the modal is open */
  isOpen: boolean;
  /** Callback to toggle the modal */
  onOpenChange: Dispatch<SetStateAction<boolean>>;
}

export const DetailsModal = ({ error, isOpen, onOpenChange }: DetailsModalProps) => {
  // determine the message to display bassed on the error type
  let msg: ApiErrorDetails | JupiterApiErrorDetails | ZodIssue[] | string;
  if (error instanceof ApiError || error instanceof JupiterApiError) {
    msg = error.details;
  } else if (error instanceof ZodError) {
    msg = error.errors;
  } else {
    msg = error.message;
  }

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      onClose={() => onOpenChange(false)}
      variant="LARGE"
    >
      <div className="items-center flex justify-between px-6 pt-4">
        <Title className={fontStyles({ variant: 'H5' })}>Error details</Title>
        <Close className={dialogCloseBtnStyles().button({ absolute: true })}>
          <XIcon aria-hidden className={dialogCloseBtnStyles().icon()} />
        </Close>
      </div>

      <div className="pb-11 px-6 pt-4">
        <Description className="block text-350 leading-[1.5] pb-6">
          <p>This information can help the support team resolve your issue.</p>
        </Description>

        <pre
          className={fontStyles({
            variant: 'BODY_SM',
            class: [
              'bg-token-gray-300',
              'border',
              'border-solid',
              'border-token-gray-600',
              'rounded-sm',
              'block',
              'p-3',
              'h-fit',
              'overflow-auto',
            ],
          })}
        >
          {JSON.stringify(msg, null, 4)}
        </pre>
      </div>
    </Modal>
  );
};
